import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCMSObject, TeleScript } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle.js';
import PromotionDropdown from '../Components/PromotionDropdown.js';

const FeedbackPage = ({ user, config, feedback, cmsSourceFirebase, actions }) => {
    const page = {
        title: getCMSObject('data.microsite.general.feedback.pageInfo.pageTitle'),
        className: 'feedback',
    };

    useEffect(() => {
        actions.feedbackActions.reset();
    }, []);

    const [disabled, setDisabled] = useState(false);
    const [name, setName] = useState(user?.player?.name ?? '');
    const [email, setEmail] = useState(user?.player?.email ?? '');
    const [promotionId, setPromotionId] = useState('');
    const [comments, setComments] = useState('');

    useEffect(() => {
        setName(user?.player?.name ?? '');
        setEmail(user?.player?.email ?? '');
    }, [user.loggedIn]);

    const submitFeedback = async (event) => {
        event.preventDefault();

        setDisabled(true);
        await actions.feedbackActions.reset();

        if (!disabled) {
            const formData = {
                name: name,
                email: email,
                promotion_id: promotionId,
                comments: comments,
            };

            await actions.feedbackActions.postFeedback(formData);
            document.querySelector('.alert').scrollIntoView(true);

            if (!feedback.isError) {
                setComments('');
            }

            setDisabled(false);
        }
    };

    const Error = () => {
        const errors = feedback.error.split(/<br\/>/g).filter((item) => {
            return item.length > 0;
        });

        return (
            <div className='alert alert-danger text-center' role='alert'>
                {errors.map((err) => {
                    var htmlFilteredError = err.replace(/<[^>]*>/g, '');
                    return <div key={err}>{htmlFilteredError}</div>;
                })}
            </div>
        );
    };

    const Success = () => {
        if (feedback.success) {
            return (
                <div className='alert alert-success text-center' role='alert'>
                    <TeleScript
                        line={getCMSObject('data.microsite.general.feedback.feedbackSuccess.contentHTML')}
                        replace={{
                            '%PROMOTION_NAME%': config?.config?.promotion,
                        }}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title={page?.title} />
                <div className='description'>
                    <TeleScript
                        line={getCMSObject('data.microsite.general.feedback.pageInfo.pageDescription.contentHTML')}
                        replace={{
                            '%PROMOTION_NAME%': config?.config?.promotion,
                        }}
                    />
                </div>
            </div>
            <div className='feedback-form-container'>
                <div className='row'>{feedback.isError ? <Error /> : <Success />}</div>
                <form
                    name='feedback_form'
                    id='feedback_form'
                    action=''
                    disabled={disabled}
                    method='post'
                    encType='application/x-www-form-urlencoded'
                    onSubmit={submitFeedback}>
                    <div className='form-group'>
                        <label htmlFor='name'>Name:</label>
                        <input
                            type='text'
                            id='name'
                            name='name'
                            value={name}
                            size='32'
                            maxLength='120'
                            onChange={(e) => setName(e.target.value)}
                            placeholder='Enter Name'
                            className='form-control'
                        />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='email'>Email:</label>
                        <input
                            type='text'
                            id='email'
                            name='email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            size='32'
                            maxLength='60'
                            placeholder='Enter E-mail'
                            className='form-control'
                        />
                    </div>
                    <PromotionDropdown
                        name='promotion'
                        id='promotion'
                        label='Promotion Name:'
                        selected={promotionId}
                        changeHandler={(e) => setPromotionId(e.target.value)}
                    />
                    <div className='form-group'>
                        <label htmlFor='comments'>Comments:</label>
                        <textarea
                            id='comments'
                            name='comments'
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            rows='5'
                            cols='50'
                            wrap='soft'
                            className='form-control'
                        />
                    </div>
                    <div className='submit-div d-flex justify-content-center mt-5'>
                        <button id='entry-submit' name='submit' type='submit' className='theme-btn theme-btn-secondary theme-btn-lg'>
                            Send Feedback
                        </button>
                    </div>
                </form>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackPage);
